import axios from 'axios'
import { useState } from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

const apiUrl =
    process.env.NODE_ENV === 'production'
        ? '/api'
        : process.env.REACT_APP_API_URL
const StyledDeleteContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(158, 18, 18, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
`

const StyledDeleteBox = styled.div`
    width: 80%;
    height: 80%;
    background-color: #5c83ab;
    display: flex;
    justify-content: center;
    align-items: center;
`

const StyledDeleteButton = styled.button`
    width: 100%;
    padding: 10px;
    background-color: #a21111;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
        background-color: #8a0e0e;
    }
`

const StyledReturnButton = styled.button`
    width: 100%;
    padding: 10px;
    background-color: #ffffff;
    color: black;
    border: none;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
        background-color: #a3a3a3;
    }
`

const ReportUser = ({ setIsReportVisible, reportedUserId }) => {
    const navigate = useNavigate()
    const [message, setMessage] = useState('Votre message ici.')
    const [isSuccess, setIsSuccess] = useState(false) // Ajouté un état pour gérer le succès
    const [isLoading, setIsLoading] = useState(false) // Pour gérer le chargement de la requête

    const handleClickClose = () => {
        setIsReportVisible(false)
    }

    // Gérer les changements de champs
    const handleChange = (e) => {
        setMessage(e.target.value)
    }

    const handleReportUser = async () => {
        try {
            setIsLoading(true) // Démarrer le chargement
            const response = await axios.post(
                `${apiUrl}/auth/messageToAdmin`,
                {
                    message,
                    reportedUserId,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    withCredentials: true, // Inclut les cookies dans la requête
                }
            )
            if (response.status === 200) {
                console.log('Message envoyé avec succès')
                setIsSuccess(true) // Si succès, changer l'état
                setTimeout(() => {
                    navigate('/Dashboard')
                }, 4000)
            }
        } catch (error) {
            console.error(
                'Erreur lors de la requête:',
                error.response ? error.response.data : error.message
            )
        } finally {
            setIsLoading(false) // Fin du chargement
        }
    }

    return (
        <StyledDeleteContainer>
            <StyledDeleteBox>
                {isSuccess ? (
                    <div>
                        <h2>Utilisateur signalé</h2>
                        <p>
                            Nous traiterons votre signalement le plus vite
                            possible.
                        </p>
                    </div>
                ) : (
                    <div>
                        <h2>Signaler l'utilisateur</h2>
                        <div>Voulez-vous vraiment le signaler ?</div>
                        <textarea
                            name="message"
                            value={message}
                            onChange={handleChange}
                            required
                        ></textarea>
                        <StyledReturnButton onClick={handleClickClose}>
                            Annuler
                        </StyledReturnButton>
                        <StyledDeleteButton
                            onClick={handleReportUser}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Envoi en cours...' : 'Signaler'}
                        </StyledDeleteButton>
                    </div>
                )}
            </StyledDeleteBox>
        </StyledDeleteContainer>
    )
}

export default ReportUser
